import React from 'react'
import queryString from 'query-string'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  Box as ButtonGroup,
  Box as Buttons,
  Callout,
  Sheet,
} from '@node-space/ui-components'
import { UpdateCryptoPayoutFormPayloadKeys } from 'pages/MassPayouts/types'
import { ErrorCodes } from 'types/errorCodes'
import { WalletTypes } from 'types/types'
import { MER_CONTACTS_ERROR_CODES } from '../../constants'

export interface MassPayoutEditRecordContainerProps {
  isEditPayoutModalVisible: boolean
  onBackHandler: () => void
  children: React.ReactNode
  onCloseModal: () => void
  onDelete?: () => void
  onUpdate?: () => void
  isLoadingDelete?: boolean
  isLoadingUpdate?: boolean
  isFormDisabled?: boolean
  errors: UpdateCryptoPayoutFormPayloadKeys
}

export const MassPayoutEditRecordContainer = ({
  isEditPayoutModalVisible,
  onBackHandler,
  children,
  onCloseModal,
  onDelete,
  onUpdate,
  isLoadingDelete,
  isLoadingUpdate,
  isFormDisabled,
  errors,
}: MassPayoutEditRecordContainerProps) => {
  const { t } = useTranslation()
  const { code, message } = errors?.travelRule || {}
  const { batchType } = queryString.parse(window.location.search) as { batchType: string }

  const isFiat = batchType?.toLowerCase() === WalletTypes.FIAT.toLowerCase()

  const isMissingContact = MER_CONTACTS_ERROR_CODES.includes(code)

  return (
    <Sheet
      isOpen={isEditPayoutModalVisible}
      header={t('massPayouts.editPayment')}
      onClose={onCloseModal}
      onBack={onBackHandler}
    >
      <Box flex flexCol width="full">
        <Box flexCol width="full" gapY={16}>
          {children}
          {isMissingContact && <Callout variant="warning">{message}</Callout>}
        </Box>
        {!isFiat && (
          <Buttons flex justify="between" paddingT={24}>
            <Button onClick={onCloseModal} variant="secondary">
              {t('cancel')}
            </Button>
            <ButtonGroup flex gapX={8}>
              <Button
                testId="remove-from-batch"
                variant="secondary"
                loading={isLoadingDelete}
                onClick={onDelete}
              >
                {t('massPayouts.removeFromBatch')}
              </Button>
              {code !== ErrorCodes.NOT_VERIFIED && (
                <Button
                  testId="update-payout"
                  loading={isLoadingUpdate}
                  onClick={onUpdate}
                  disabled={isFormDisabled}
                >
                  {!isMissingContact ? t('massPayouts.update') : t('massPayouts.assignContact')}
                </Button>
              )}
            </ButtonGroup>
          </Buttons>
        )}
      </Box>
    </Sheet>
  )
}
